export type ArchiveItem = {
  slug: string;
  name: string;
  role: string;
  tag: string;
  heat: number;
  day: string;
  reading: string;
  quote: string;
  summary: string;
  detail: string[];
  bullets: { k: string; v: string }[];
  imgs: { src: string; alt: string }[];
  category: string;
  views: number;
};

export type Category = {
  slug: string;
  name: string;
  tagline: string;
  count: string;
};

export const categories: Category[] = [
  { slug: "yan-yi", name: "演艺新星", tagline: "影视剧综冒头的新面孔", count: "28 位" },
  { slug: "duan-shi", name: "短剧新秀", tagline: "竖屏爆款里眼熟的新人", count: "36 位" },
  { slug: "xuan-xiu", name: "选秀回锅", tagline: "二次登台重获关注的新人", count: "19 位" },
  { slug: "zhu-bo", name: "直播新锐", tagline: "从直播间走红的新人面孔", count: "24 位" },
  { slug: "da-huo", name: "带货新势力", tagline: "边卖边火的话题新主播", count: "16 位" },
];

export const archives: ArchiveItem[] = [
  {
    slug: "chen-yue-wan",
    name: "陈月晚",
    role: "新晋短剧女主",
    tag: "爆火新秀",
    heat: 96,
    day: "2026.09.08",
    reading: "4 分钟",
    quote: "一条口播带火一部剧，她成了竖屏界本月最眼熟的新面孔。",
    summary:
      "靠一条短短几十秒的破碎感口播意外破圈，新晋短剧女主陈月晚在一个月里被反复提起，从素人试镜到话题主角，走红节奏快得让人来不及做心理建设。",
    detail: [
      "陈月晚本是在读表演系学生，此前只接过几句台词的群演。今年春天她抱着玩票心态投了某短剧公司的线上试镜，导演组原只是缺一个能撑住哭戏的临时替补，却因为她一条随手拍的试戏花絮在内部疯传，直接从候补被抬成了女一号。",
      "剧集上线后，她那一句带着哭腔的台词被剪辑成无数条二创视频，短时间内登上多个短视频平台的榜一。观众起初是冲着剧情点进去，出来却都在搜「这个新面孔叫什么」。短短三周，陈月晚相关话题阅读量一路走高，成了圈内公认的本季新爆料主角。",
      "走红之后，关于她的过去也陆续被翻出：早年的街边演唱视频、宿舍里素颜的日常、一段未播完的小成本网大。比起铺天盖地的所谓「新人黑料」，多数路人反而觉得她底色干净，白月光般的新面孔瓜里，她是最被路人盘偏爱的那一档。",
      "业内人士提醒，短剧更新换代极快，单部爆款能否沉淀成稳定观众缘，关键看下一部作品的选型。对陈月晚而言，眼下最重要的不是接更多戏，而是别在流量里弄丢最开始那份让人共情的东西。",
    ],
    bullets: [
      { k: "身份", v: "新晋短剧女主" },
      { k: "破圈点", v: "破碎感哭戏口播" },
      { k: "热度轨迹", v: "素人→试镜→女主→话题主角" },
      { k: "路人盘", v: "偏正面，好感度高" },
    ],
    imgs: [
      { src: "https://readdy.ai/api/search-image?query=Elegant%20young%20chinese%20actress%20portrait%2C%20soft%20window%20light%2C%20minimal%20cream%20background%2C%20light%20brown%20hair%2C%20gentle%20sad%20expression%2C%20editorial%20magazine%20style%20photo%2C%20warm%20tone%2C%20high%20quality&width=640&height=800&seq=chen-wan-01&orientation=portrait", alt: "新晋短剧女主陈月晚档案写真" },
    ],
    category: "duan-shi",
    views: 128400,
  },
  {
    slug: "lu-shen",
    name: "陆深",
    role: "翻红选秀选手",
    tag: "回锅热议",
    heat: 92,
    day: "2026.09.07",
    reading: "5 分钟",
    quote: "五年前被淘汰的那句遗憾，今年他靠一场即兴solo翻了盘。",
    summary:
      "曾止步赛区前十的选秀旧人陆深，今年以成熟姿态重返舞台，一首自作曲在赛程过半时突然爆红。他带着「第二张入场券」的新人心态重新出发，也成了本届热议的翻红主角。",
    detail: [
      "陆深的名字，老粉并不陌生。五年前他止步某档选秀赛区前十，退场时那句「我还是太嫩了」被剪进节目花絮，成了不少人的意难平。之后他转去做幕后，写歌、编曲、给新人做配唱，几乎淡出幕前。",
      "今年节目组发出返场邀请，起初他犹豫了很久。经纪团队劝他别吃回头草，可他还是来了，理由是「想给当年那个不甘心的自己一个交代」。赛程过半，他抱着吉他在台上即兴完成的一段创作被完整保留，一夜之间成为话题。",
      "观众讨论他的角度很特别：没人在意什么「旧瓜新吃」，大家更关心一个被时间磨过的声音还能不能打动人。他输过、绕路过、也几乎放弃过，这些反而成了他这轮新面孔瓜里最有分量的注脚。",
      "节目组透露，决赛选曲里他特意加入了一段五年前没唱成的副歌。对陆深而言，翻红不只是重新被看见，更是终于能和自己和解。至于能不能走到最后，他说已经没那么重要了。",
    ],
    bullets: [
      { k: "身份", v: "翻红选秀选手" },
      { k: "破圈点", v: "即兴自作曲solo" },
      { k: "热度轨迹", v: "旧人→幕后→返场→翻红" },
      { k: "路人盘", v: "意难平型，情绪共鸣强" },
    ],
    imgs: [
      { src: "https://readdy.ai/api/search-image?query=Thoughtful%20young%20chinese%20male%20singer%20portrait%2C%20holding%20acoustic%20guitar%2C%20warm%20stage%20backlight%2C%20minimal%20dark%20warm%20background%2C%20editorial%20magazine%20photo%2C%20mature%20gentle%20expression%2C%20high%20quality&width=640&height=800&seq=lu-shen-01&orientation=portrait", alt: "翻红选秀选手陆深舞台档案写真" },
    ],
    category: "xuan-xiu",
    views: 114800,
  },
  {
    slug: "song-yao",
    name: "宋遥",
    role: "新晋歌手",
    tag: "黑马新人",
    heat: 88,
    day: "2026.09.06",
    reading: "3 分钟",
    quote: "低音开口跪，歌单收藏破百万的新面孔。",
    summary:
      "名不见经传的原创歌手宋遥，凭借一首低音质感的慢歌在深夜被算法推到大量用户的歌单里。没有大公司力捧，他靠作品本身完成了从无名到被反复安利的进阶。",
    detail: [
      "宋遥的走红几乎没有预兆。一首demo质量的慢歌在一个周五深夜突然被推上热榜，没有综艺、没有热搜、没有宣传通稿，有的只是用户自发的一句「这声音能处」。不到十天，这首歌的收藏量迅速破百万。",
      "圈内人复盘时发现，这并非偶然。他早几年就在音乐平台上发过几十首冷门作品，词曲都是自己包办，音色辨识度高，只是一直缺一个被听见的入口。算法的这一推，恰好撞上了他多年积累的存量。",
      "走红后，关于他的采访陆续流出。他把录音棚选在县城老家改造的老屋里，拒绝了不少综艺邀约，理由是「想先把手上的十首存货录完」。这种不急着变现的松弛感，让他在新面孔瓜里显得格外难得。",
      "目前各大厂牌都在找他谈合作，他经纪人透露宋遥只提了一个要求：专辑里的歌必须自己说了算。对一个刚冒头的新人来说，这或许比什么都重要。",
    ],
    bullets: [
      { k: "身份", v: "新晋原创歌手" },
      { k: "破圈点", v: "低音慢歌被算法推荐" },
      { k: "热度轨迹", v: "无名→demo走红→被安利" },
      { k: "路人盘", v: "作品型，口碑稳" },
    ],
    imgs: [
      { src: "https://readdy.ai/api/search-image?query=Young%20chinese%20male%20singer%20portrait%20in%20studio%2C%20warm%20neon%20and%20desk%20lamp%20lighting%2C%20minimal%20dark%20background%2C%20holding%20microphone%2C%20editorial%20magazine%20photo%2C%20deep%20voice%20mood%2C%20high%20quality&width=640&height=800&seq=song-yao-01&orientation=portrait", alt: "新晋歌手宋遥音乐档案写真" },
    ],
    category: "yan-yi",
    views: 98800,
  },
  {
    slug: "an-lin",
    name: "安林",
    role: "带货主播新贵",
    tag: "边卖边火",
    heat: 90,
    day: "2026.09.05",
    reading: "4 分钟",
    quote: "不喊「家人们」，他靠拆解成分把直播做成了公开课。",
    summary:
      "从家电品牌方转行做自播的安林，用讲成分、摆数据的理性方式重新定义了带货直播间。他几乎不喊话式促销，直播间却场场爆满，成了新晋带货主播里最特别的一支新势力。",
    detail: [
      "在成为主播之前，安林做了五年某家电品牌的线下培训讲师。他第一次开播是被品牌方临时拉壮丁顶上，结果一场不按套路出牌的「成分讲解」意外留住大量观众，也让品牌方看到了另一种直播的可能性。",
      "他的直播间没有背景音乐轰炸，也没有「最后三单」的话术。他会把样品拆开，指着标签逐项讲成分、讲产地、讲适用人群，偶尔还会直接说「这件不适合你，别买」。这种近乎「劝退」的真诚，反而让下单转化出奇地高。",
      "安林走红之后，同行纷纷研究他的打法，有人模仿他的理性口吻，却学不来他背后的产品功底。他的团队透露，选品清单上每一件都是他本人实测过至少两周的，这个习惯从品牌方时代延续至今。",
      "在直播圈新人频出、翻车不断的当下，安林这种「慢热型」新势力成了平台难得的正面样本。至于能火多久，他说看数据，也看愿不愿意继续把功课做扎实。",
    ],
    bullets: [
      { k: "身份", v: "带货主播新贵" },
      { k: "破圈点", v: "成分拆解式理性直播" },
      { k: "热度轨迹", v: "培训讲师→自播→新贵" },
      { k: "路人盘", v: "专业感，信任型" },
    ],
    imgs: [
      { src: "https://readdy.ai/api/search-image?query=Confident%20young%20chinese%20male%20live%20host%20portrait%2C%20smart%20casual%20outfit%2C%20product%20on%20desk%2C%20warm%20studio%20lighting%2C%20clean%20background%2C%20editorial%20magazine%20photo%2C%20professional%20trustworthy%20mood%2C%20high%20quality&width=640&height=800&seq=an-lin-01&orientation=portrait", alt: "带货主播新贵安林直播间档案写真" },
    ],
    category: "da-huo",
    views: 87600,
  },
  {
    slug: "qiao-shu",
    name: "乔树",
    role: "短剧反派专业户",
    tag: "反派出圈",
    heat: 85,
    day: "2026.09.04",
    reading: "4 分钟",
    quote: "演反派演到观众「求他别洗白」，这是头一回。",
    summary:
      "把短剧里的渣男反派演得入木三分的乔树，靠「让人恨得牙痒」反向出圈。观众在评论区一边骂角色一边夸演技，他成了新面孔瓜里最有记忆点的存在。",
    detail: [
      "乔树这张脸，追竖屏短剧的观众不会陌生。他几乎承包了近半年爆款短剧里最讨人厌的男二号，从甩狠话到眼神戏都拿捏到位，弹幕里每天都有观众在喊「气得血压高了」。",
      "有意思的是，角色越招人恨，演员本人越吃香。乔树的走红路径很「反常识」——观众看完戏去搜演员，发现现实里的他腼腆又话少，和屏幕里判若两人，这种反差让他的关注度不降反升。",
      "他坦言接反派是「曲线救国」。刚毕业那阵他试镜男主角屡屡碰壁，后来经纪人说「反派也是主角」，他索性把每一个工具人反派都演出立体感，慢慢熬出了自己的辨识度。",
      "如今剧本方开始反过来为他定制「非典型反派」，甚至有平台想给他单独开一部大男主戏。对乔树而言，把坏事演得让人信，本身就是一件值得被记住的事。",
    ],
    bullets: [
      { k: "身份", v: "短剧反派专业户" },
      { k: "破圈点", v: "角色恨感+真人反差" },
      { k: "热度轨迹", v: "屡屡碰壁→反派专业户→出圈" },
      { k: "路人盘", v: "角色与本人双反差" },
    ],
    imgs: [
      { src: "https://readdy.ai/api/search-image?query=Dramatic%20portrait%20of%20young%20chinese%20male%20actor%20as%20villain%2C%20intense%20half%20shadow%20face%2C%20dark%20warm%20background%2C%20editorial%20cinematic%20lighting%2C%20moody%20expression%2C%20high%20quality&width=640&height=800&seq=qiao-shu-01&orientation=portrait", alt: "短剧反派专业户乔树反差档案写真" },
    ],
    category: "duan-shi",
    views: 82300,
  },
  {
    slug: "mei-er",
    name: "梅儿",
    role: "直播全能新锐",
    tag: "才艺直播",
    heat: 82,
    day: "2026.09.03",
    reading: "3 分钟",
    quote: "会唱会跳会讲段子，直播间里没有冷场这一说。",
    summary:
      "靠才艺与即兴互动积累人气的直播新锐梅儿，把直播间做成了小型才艺秀现场。她不靠露脸博眼球，凭一场场高质量直播在一年内从素人成长为平台头部新锐。",
    detail: [
      "梅儿第一场直播只有七个观众，其中三个还是来巡查的运营。但她没想过放弃，每天固定开播，把会唱的歌一首首练熟，慢慢摸索出属于自己的「点歌+互动+段子」节奏，观众数量开始稳步爬坡。",
      "真正让她被更多人记住的，是去年一场临时救场的跨主播连麦。主办方安排的嘉宾临时爽约，她顶上去即兴撑满了整场，控场、接梗、圆场一气呵成，让不少路人第一次记住了这个能扛事的新人。",
      "直播之外，梅儿对「边界感」看得很清。她明确表示不做擦边内容，也拒了不少高价但不合适的方向，理由是「想走长远」。这份清醒让她在同行新人里显得格外难得。",
      "现在她正筹备自己的工作室，打算把成熟的直播间模式复制出去。对一个从七个人看到满屏弹幕的新人来说，这已经是很长一段路了。",
    ],
    bullets: [
      { k: "身份", v: "直播全能新锐" },
      { k: "破圈点", v: "即兴救场+才艺直播" },
      { k: "热度轨迹", v: "7观众→连麦救场→平台头部新锐" },
      { k: "路人盘", v: "才艺型，氛围好" },
    ],
    imgs: [
      { src: "https://readdy.ai/api/search-image?query=Cheerful%20young%20chinese%20female%20streamer%20portrait%2C%20colorful%20ring%20light%2C%20dynamic%20pose%2C%20modern%20studio%20background%2C%20editorial%20magazine%20photo%2C%20energetic%20friendly%20mood%2C%20high%20quality&width=640&height=800&seq=mei-er-01&orientation=portrait", alt: "直播全能新锐梅儿才艺档案写真" },
    ],
    category: "zhu-bo",
    views: 75600,
  },
  {
    slug: "chen-xi-nan",
    name: "陈西南",
    role: "选秀全能王",
    tag: "综合第一",
    heat: 89,
    day: "2026.09.02",
    reading: "5 分钟",
    quote: "vocal、dance、创作样样行，他的短板是「太全能」。",
    summary:
      "本届选秀综合排名第一的陈西南，是少有的vocal与dance兼具、还能自己写词的新人。他曾被调侃「全能到没有记忆点」，直到决赛舞台一首自作曲让所有人闭嘴。",
    detail: [
      "陈西南的履历在同届新人里相当能打：练过八年舞，专业声乐出身，还私下写过上百首歌。初舞台他一口气展现三段不同技能，导师看得直点头，却也有人担心——太全能的人，往往很难被单一标签记住。",
      "这个顾虑在决赛舞台被打消。他把自己写的一首关于「追梦与告别」的歌搬上舞台，边唱边跳，间奏里一段即兴钢琴把情绪推到顶点，弹幕瞬间刷屏。那一刻，观众记住的不再是「全能工具人」，而是一个有表达欲的完整的人。",
      "赛后关于他的讨论很热闹，有人说他是本届唯一没有明显短板的选手，也有人开始考古他早期的舞蹈视频，说他「卷」得早、底子厚。所谓新人黑料，在他身上几乎扒不出负面，反倒是一路的练习痕迹被越挖越正能量。",
      "如今他手握多个合作邀约，却选择先回训练室把新歌打磨完。经纪团队评价他「清醒得不像新人」——在流量最热的时候，他更想守住作品这个基本盘。",
    ],
    bullets: [
      { k: "身份", v: "选秀全能选手" },
      { k: "破圈点", v: "决赛自作曲舞台" },
      { k: "热度轨迹", v: "全能无短板→决赛自作曲→综合第一" },
      { k: "路人盘", v: "实力型，无负面考古" },
    ],
    imgs: [
      { src: "https://readdy.ai/api/search-image?query=Versatile%20young%20chinese%20male%20idol%20portrait%2C%20dynamic%20dance%20pose%2C%20concert%20stage%20lighting%2C%20warm%20amber%20and%20red%20tones%2C%20editorial%20magazine%20photo%2C%20confident%20expression%2C%20high%20quality&width=640&height=800&seq=chen-xn-01&orientation=portrait", alt: "选秀全能王陈西南舞台档案写真" },
    ],
    category: "xuan-xiu",
    views: 97800,
  },
  {
    slug: "jiang-bai",
    name: "江白",
    role: "新晋电影配角",
    tag: "大银幕新人",
    heat: 80,
    day: "2026.09.01",
    reading: "4 分钟",
    quote: "全片只有十二句台词，她却让观众记住了整场戏。",
    summary:
      "在大银幕上一句台词都没有的配角江白，用一场仅几十秒的无声表演成了话题。导演评价她「把沉默演出了一整段人生」，这位新晋电影新人也被越来越多影迷列入期待名单。",
    detail: [
      "江白进组的经历很普通：一场试镜、一页纸的角色小传、一个没有名字只写着「店员的妻子」的角色。她原本只是来刷个脸，没想到导演在看完她的无声试戏后，临时把这个角色的戏份加到了全片最重的一场。",
      "那场戏里她没有台词，只有转身、停顿、再转身时眼角的一滴泪。影片上映后，这段被影迷反复截取，弹幕里讨论最多的不是剧情，而是「这个新面孔是谁」。靠一场无对白的表演被看见，在当今圈子里并不多见。",
      "江白说这份「被看见」她等了很久。她科班出身却常年接不到戏，为了维持生计做过咖啡师，也试过转行，唯一没放下的是每天对着镜子练戏的习惯。她的坚持，在这届新面孔瓜里成了被提及最多的励志样本。",
      "眼下不少文艺片导演向她递出橄榄枝。她依然保持谨慎，只接自己读得懂的角色。对一个把十二句台词演成高光的演员来说，挑戏的眼光可能比戏约数量更重要。",
    ],
    bullets: [
      { k: "身份", v: "新晋电影配角" },
      { k: "破圈点", v: "一场无台词高光戏" },
      { k: "热度轨迹", v: "无名→试镜→高光配角→被期待" },
      { k: "路人盘", v: "影迷型，文艺向" },
    ],
    imgs: [
      { src: "https://readdy.ai/api/search-image?query=Understated%20young%20chinese%20female%20actress%20portrait%2C%20soft%20cinematic%20side%20light%2C%20film%20noir%20style%20dark%20background%2C%20quiet%20emotional%20expression%2C%20editorial%20magazine%20photo%2C%20high%20quality&width=640&height=800&seq=jiang-bai-01&orientation=portrait", alt: "新晋电影配角江白大银幕档案写真" },
    ],
    category: "yan-yi",
    views: 69800,
  },
  {
    slug: "tang-su",
    name: "唐酥",
    role: "短剧搞笑担当",
    tag: "喜剧新人",
    heat: 78,
    day: "2026.08.31",
    reading: "3 分钟",
    quote: "自带表情包体质，一出场弹幕就笑不活了。",
    summary:
      "靠夸张却不油腻的喜剧表演出圈的短剧新人唐酥，自带天然喜感，几乎每个表情都能被做成表情包。她证明了「搞笑」也是一种被低估的硬实力。",
    detail: [
      "唐酥没有专业喜剧训练，她最开始的舞台是大学话剧社。毕业后她拍了几年小成本短剧，演的多是插科打诨的小配角，直到一次意外顶替女主角的机会，才让她的喜剧天赋被观众正式看见。",
      "她的表演自带一种「认真搞笑」的真诚感，不靠卖丑也不靠低俗梗，凭精准的表情控制和节奏感制造笑点。观众自发把她截图做成表情包，「唐酥一皱眉就知道要出事了」成了她最出圈的一句梗。",
      "走红之后，唐酥被问到最多的问题是「喜剧演员有没有容貌焦虑」。她答得坦然：比起外貌，她更怕自己的梗过时，所以一直在学新东西，观察生活、记段子，把笑点建立在真实观察上。",
      "眼下她正在筹备一档自己的喜剧综艺。圈内评价她「路子正、底色好」，在新面孔瓜里，她是那种能让你轻松记住、也愿意一直追着看下去的新人。",
    ],
    bullets: [
      { k: "身份", v: "短剧搞笑担当" },
      { k: "破圈点", v: "表情包体质+节奏感" },
      { k: "热度轨迹", v: "话剧社→小配角→顶替女主→出圈" },
      { k: "路人盘", v: "喜剧向，观众缘强" },
    ],
    imgs: [
      { src: "https://readdy.ai/api/search-image?query=Playful%20young%20chinese%20female%20comedian%20portrait%2C%20funny%20surprised%20expression%2C%20bright%20vibrant%20studio%20background%2C%20editorial%20magazine%20photo%2C%20lighthearted%20happy%20mood%2C%20high%20quality&width=640&height=800&seq=tang-su-01&orientation=portrait", alt: "短剧搞笑担当唐酥喜剧档案写真" },
    ],
    category: "duan-shi",
    views: 63200,
  },
  {
    slug: "gu-chen",
    name: "顾辰",
    role: "直播知识型新锐",
    tag: "硬核科普",
    heat: 76,
    day: "2026.08.30",
    reading: "4 分钟",
    quote: "把冷门知识讲得津津有味，他的弹幕全是「再来一段」。",
    summary:
      "专注科普冷门知识的直播新锐顾辰，用一个个「反常识冷知识」吸引了一批高粘性观众。他不追热点不蹭流量，却在竞争激烈的直播赛道里稳稳站住了脚。",
    detail: [
      "顾辰最开始在某问答平台写科普帖，粉丝不多但都很铁。转战直播后，他延续了「认真把一个冷知识讲透」的风格，从「为什么蚊子总叮你」讲到「一块钱的硬币是怎么被造的」，每次都把冷知识讲得通俗又有趣。",
      "他从不刻意制造话题，弹幕里有观众提问，他就当场查证、现场演示，错了就大方纠正。这种严谨反而成了他的记忆点，不少观众留言「听顾老师讲完，我能跟朋友吹一天」。",
      "平台方透露，顾辰的粉丝里高学历、高粘性用户占比很高，广告价值也因此水涨船高。在直播圈新人靠噱头抢流量的当下，他证明了「硬核内容」同样能成为新面孔出圈的方式。",
      "顾辰的下一步计划是做一档系列科普节目。他说直播是入口，但真正想留下的，是那些经得起时间检验的知识内容。",
    ],
    bullets: [
      { k: "身份", v: "直播知识型新锐" },
      { k: "破圈点", v: "冷知识科普+严谨纠错" },
      { k: "热度轨迹", v: "问答平台→直播→硬核新锐" },
      { k: "路人盘", v: "知识型，粘性高" },
    ],
    imgs: [
      { src: "https://readdy.ai/api/search-image?query=Curious%20young%20chinese%20male%20knowledge%20streamer%20portrait%2C%20holding%20book%2C%20warm%20study%20lamp%20lighting%2C%20bookshelf%20background%2C%20editorial%20magazine%20photo%2C%20intellectual%20friendly%20mood%2C%20high%20quality&width=640&height=800&seq=gu-chen-01&orientation=portrait", alt: "直播知识型新锐顾辰科普档案写真" },
    ],
    category: "zhu-bo",
    views: 58900,
  },
  {
    slug: "su-man",
    name: "苏曼",
    role: "新晋唱跳女主",
    tag: "上升新人",
    heat: 74,
    day: "2026.08.29",
    reading: "4 分钟",
    quote: "从舞房到舞台，她用一支intro让路人记住自己。",
    summary:
      "原舞蹈老师出身的苏曼，以一支高难度intro舞在大热剧集宣传期迅速走红。她唱跳兼具，被业内视为新晋上升势头最猛的全能女主之一。",
    detail: [
      "苏曼在成为演员前是某知名舞室的编舞老师，给不少艺人的舞台做过伴舞。转行当演员，她最初的履历并不亮眼，客串几部剧都只是小透明，直到剧组宣传期她随手跳的一支intro舞被放出，才让观众惊呼「原来这个新面孔这么能跳」。",
      "那支舞没有复杂布景，只有她一个人、一段音乐和一镜到底的调度，却因为完成度和表现力在短视频平台刷屏。一夜之间，她相关话题阅读量猛增，片方顺势安排她在下一部戏里挑战唱跳角色。",
      "圈内人分析她的优势：舞蹈功底给了她极好的镜头感，专业出身又让她比一般新人更懂「舞台语言」。她不靠绯闻博眼球，靠实打实的业务能力让「上升新人」四个字有了具象的解释。",
      "眼下苏曼手里同时压着两部戏和一支单曲计划，档期排得满满当当。她笑着说现在最缺的是睡眠，但比当年在舞室练到凌晨的日子，已经幸福太多。",
    ],
    bullets: [
      { k: "身份", v: "新晋唱跳女主" },
      { k: "破圈点", v: "一镜到底intro舞" },
      { k: "热度轨迹", v: "舞蹈老师→小透明→intro出圈→上升" },
      { k: "路人盘", v: "业务型，舞台向" },
    ],
    imgs: [
      { src: "https://readdy.ai/api/search-image?query=Dynamic%20young%20chinese%20female%20dancer%2Factress%20portrait%2C%20mid%20dance%20pose%2C%20neon%20dance%20studio%20lighting%2C%20modern%20background%2C%20editorial%20magazine%20photo%2C%20elegant%20powerful%20mood%2C%20high%20quality&width=640&height=800&seq=su-man-01&orientation=portrait", alt: "新晋唱跳女主苏曼舞台档案写真" },
    ],
    category: "yan-yi",
    views: 54700,
  },
];

export const hotArchive = [...archives]
  .sort((a, b) => b.heat - a.heat)
  .slice(0, 6);